import React, { Component } from 'react'
import ReactDOMServer from 'react-dom/server'
import { initializeTooltips } from '../../files/tooltips'

class HintIcon extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    initializeTooltips()
  }

  render() {
    const { faIcon, className, placement, children, label } = this.props
    const template = '<div class="tooltip hint-icon" role="tooltip">' +
                       '<div class="tooltip-arrow"></div>' +
                       '<div class="tooltip-inner"></div>' +
                     '</div>'

    // Bootstrap copies the tooltip into aria-label, which a bare icon span may only carry as an image
    return (
      <span
        className={className}
        role={label ? undefined : 'img'}
        data-bs-toggle='tooltip'
        data-bs-html='true'
        data-bs-placement={placement || 'bottom'}
        data-bs-fallback-placements='[]'
        data-bs-template={template}
        title={ReactDOMServer.renderToStaticMarkup(children)}
      >
        <i className={`fa fa-${faIcon} me-0`} aria-hidden='true' />
        {label && <span className='ms-2'>{label}</span>}
      </span>
    )
  }
}

export default HintIcon
